module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todos.length),
      expression: "todos.length"
    }],
    staticClass: "main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allDone),
      expression: "allDone"
    }],
    staticClass: "toggle-all",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allDone) ? _vm._i(_vm.allDone, null) > -1 : (_vm.allDone)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allDone,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allDone = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allDone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allDone = $$c
        }
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "todo-list"
  }, _vm._l((_vm.filteredTodos), function(todo) {
    return _c('to-do-list-item', {
      attrs: {
        "todo": todo
      },
      on: {
        "remove-todo": _vm.removeTodo,
        "remove-completed": _vm.removeCompleted
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0f363240!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToDoList.vue
// module id = 30
// module chunks = 1